export default __webpack_public_path__ + "static/media/fpay2.9bd1c9b9.svg";